const KEY = "inlight_light"; // "auto" | "dawn" | "moon"

export const autoLight = () => {
  const h = new Date().getHours();
  return h >= 6 && h < 18 ? "dawn" : "moon";
};

export const readPreference = () => localStorage.getItem(KEY) || "auto";

export const resolveLight = (pref = readPreference()) =>
  pref === "auto" ? autoLight() : pref;

export const applyLight = (pref = readPreference()) => {
  const light = resolveLight(pref);
  document.documentElement.dataset.light = light;
  return light;
};

export const setPreference = (pref) => {
  localStorage.setItem(KEY, pref);
  return applyLight(pref);
};
